<template>
    <div class="view-legacy">
        <div class="subtitle-1 text-center">
            Login using Gappt account
            <v-img class="mx-auto"
                alt="gappt"
                   src="/images/gappt.png"
                   lazy-src="/images/gappt.png"
                   width="75px" height="28px"></v-img>
        </div>
        <v-card-text>
            <v-form>
                <v-text-field
                    v-model="form.login"
                    label="Login"
                    name="login"
                    prepend-icon="person"
                    type="text"
                    color="primary darken-4"
                    :rules="rules.login"
                    :loading="loading"
                    autofocus
                ></v-text-field>

                <v-text-field
                    v-model="form.password"
                    id="password"
                    label="Password"
                    name="password"
                    prepend-icon="lock"
                    type="password"
                    color="primary darken-4"
                    :loading="loading"
                    :rules="rules.password"
                    v-on:keyup.enter="canLogin ? login() : false"
                ></v-text-field>
            </v-form>
        </v-card-text>
        <v-card-actions>
            <v-btn text small color="black--text"
                   href="https://gappt.com/login/forgot"
                   target="_blank">Forgot your password?
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn large
                   text
                   @click="back()">
                Back
            </v-btn>
            <v-btn large
                   color="primary darken-4 white--text"
                   :disabled="loading || !canLogin"
                   @click="login">
                Login
            </v-btn>
        </v-card-actions>
        <v-overlay :value="loading">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-row justify="center">
            <v-dialog v-model="error" persistent max-width="290">
                <v-card>
                    <v-card-title class="headline">Login failed</v-card-title>
                    <v-card-text>
                        Login details didn't match our records.<br/>
                        Please check your details and try again.
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="black" text @click="error = false">OK</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
    import {passwordMixin} from '../mixins/password'

    export default {
        name: "Legacy",
        mixins: [passwordMixin]
    }
</script>

<style scoped>

</style>
